import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function AdminConsentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const tenantId = searchParams.get('state');
  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');
  const adminConsent = searchParams.get('admin_consent');

  useEffect(() => {
    if (adminConsent === 'True' && !error) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate(`/users/${tenantId}`);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [adminConsent, error, tenantId, navigate]);

  if (error) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}>
        <div style={{
          background: 'white',
          padding: '50px',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          maxWidth: '600px',
          textAlign: 'center',
        }}>
          <span style={{ fontSize: '64px' }}>❌</span>
          <h1 style={{ margin: '20px 0', color: '#dc2626' }}>Consent Not Granted</h1>
          <p style={{ color: '#6b7280', marginBottom: '10px' }}>{errorDescription || error}</p>
          <p style={{ color: '#6b7280', fontSize: '14px' }}>
            Admin consent is required to sync users and groups from Microsoft 365.
          </p>
          <button
            onClick={() => navigate(`/users/${tenantId}`)}
            style={{
              marginTop: '30px',
              padding: '12px 32px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Back to Users
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        padding: '50px',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        maxWidth: '600px',
        textAlign: 'center',
      }}>
        <span style={{ fontSize: '64px' }}>✅</span>
        <h1 style={{ margin: '20px 0', color: '#059669' }}>Admin Consent Granted!</h1>
        <p style={{ color: '#6b7280', marginBottom: '30px' }}>
          VirtueSign can now sync users and groups from your Microsoft 365 organization.
        </p>
        <div style={{
          background: '#dbeafe',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '20px',
        }}>
          <p style={{ margin: 0, color: '#1e40af', fontSize: '14px' }}>
            Redirecting to user management in <strong>{countdown}</strong> seconds...
          </p>
        </div>
        <button
          onClick={() => navigate(`/users/${tenantId}`)}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Go Now
        </button>
      </div>
    </div>
  );
}
